import { render, staticRenderFns } from "./leadsPerSetting.vue?vue&type=template&id=6fbf117e"
import script from "./leadsPerSetting.vue?vue&type=script&lang=js"
export * from "./leadsPerSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports